import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import moment from "moment";
import MonthInput from "./MonthInput";
import DayInput from "./DayInput";
import YearInput from "./YearInput";
import TextInput from "./TextInput";

export class SignatureModal extends PureComponent {
  state = {
    showSignature: false,
  };

  componentDidMount() {
    const {
      signatureDay,
      signatureMonth,
      signatureYear,
      signatureStatement,
      formText,
    } = this.props;
    signatureDay.autofill(moment().format("DD"));
    signatureMonth.autofill(moment().format("MM"));
    signatureYear.autofill(moment().format("YYYY"));
    signatureStatement.autofill(formText.signatureStatement);
  }

  componentDidUpdate(prevProps) {
    const { formText, signatureStatement } = this.props;
    if (formText.signatureStatement !== prevProps.formText.signatureStatement) {
      signatureStatement.autofill(formText.signatureStatement);
    }
  }

  render() {
    const {
      showSignature,
      openSignature,
      closeSignature,
      handleSubmit,
      signatureField,
      signatureDay,
      signatureMonth,
      signatureYear,
      text,
      formText,
      formEnglishOverride,
    } = this.props;

    const is850Form = formText.signatureTitle == "Sign Form 8850";
    return (
      <Modal
        isOpen={showSignature}
        toggle={openSignature}
        modalClassName="signature-dialog"
        size="lg"
      >
        <div className="semicircle-button-container">
          <div className="semicircle-button done" onClick={closeSignature}>
            {"×"}
          </div>
        </div>
        <ModalHeader>
          <div className="page-title-container">
            <div className="page-title">{text.signatureTitle}</div>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="text signature-statement">
            <strong>
              {text.signatureStatementLabel}
              {": "}
            </strong>
            {text.signatureStatement}
          </div>

          {formEnglishOverride && (
            <div className="text signature-statement">
              <strong>
                {formText.signatureStatementLabel}
                {": "}
              </strong>
              {formText.signatureStatement}
            </div>
          )}

          <form onSubmit={handleSubmit} className="form-horizontal">
            <div className="row">
              <div className="col-sm-6 col-lg-5">
                <div className="wizard-text">{text.signatureLabel}</div>
                <TextInput text={text} field={signatureField} />
              </div>

              <div className="col-sm-6 col-lg-5">
                <div className="wizard-text">{text.todaysDate}</div>
                <fieldset disabled="disabled" className="fieldsetStyle">
                  <div className="row">
                    <div className="col-4">
                      <MonthInput text={text} field={signatureMonth} />
                    </div>
                    <div className="col-3 cell-tight">
                      <DayInput
                        text={text}
                        field={signatureDay}
                        monthSelected={signatureMonth}
                        yearSelected={signatureYear}
                      />
                    </div>
                    <div className="col-5">
                      <YearInput
                        text={text}
                        field={signatureYear}
                        monthSelected={signatureMonth}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>

              <div className="col">
                <div className="wizard-text">&nbsp;</div>
                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <Button
                        color="primary"
                        size="lg"
                        block={true}
                        type="submit"
                      >
                        {text.sign}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {is850Form && (
              <div className="separator">
                <hr />
              </div>
            )}
            <div className="row">
              <div className="col">
                <div className="wizard-text privacy-act-notice">
                  <strong>{text.privacyActTitle}</strong>
                </div>
                <div className="wizard-text privacy-act-notice italic">
                  {text.privacyActSubtitle}
                  <br />
                </div>
                <br />
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct01}
                </div>
              </div>
              <div className="col">
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct02a}
                  <br />
                  <br />
                </div>
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct02b}
                  <br />
                  <br />
                </div>
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct02c}
                  <br />
                  <br />
                </div>
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct02d}
                </div>
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct02e}
                </div>
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct03}
                  <br />
                  <br />
                </div>
              </div>
              <div className="col">
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct03a}
                  <br />
                  <br />
                </div>
                <div className="wizard-text privacy-act-notice">
                  {text.privacyAct03b}
                  <br />
                  {text.privacyAct03c}
                  <br />
                  {text.privacyAct03d}
                  <br />
                  {text.privacyAct03e}
                </div>
                <div className="wizard-text privacy-act-notice">
                  <br />
                  {text.privacyAct03f}
                  <br />
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>
    );
  }
}

SignatureModal.propTypes = {
  closeSignature: PropTypes.func.isRequired,
  formEnglishOverride: PropTypes.bool,
  formText: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  openSignature: PropTypes.func.isRequired,
  showSignature: PropTypes.bool.isRequired,
  signatureDay: PropTypes.object.isRequired,
  signatureField: PropTypes.object.isRequired,
  signatureMonth: PropTypes.object.isRequired,
  signatureYear: PropTypes.object.isRequired,
  signatureStatement: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
};

export default SignatureModal;



// WEBPACK FOOTER //
// ./src/components/SignatureModal.js